import { jsx as e, jsxs as v } from "react/jsx-runtime";
import b from "react";
import { Provider as g, Root as j, Trigger as P, Portal as T, Content as _ } from "../../node_modules/@radix-ui/react-tooltip/dist/index.es.js";
import r from "../../_virtual/index.es.js";
import { tooltipContentStyles as $ } from "./Tooltip.styles.es.js";
const H = b.forwardRef(({
  text: i,
  children: d,
  hide: f,
  className: l,
  classNames: t,
  props: o,
  fontSize: h,
  position: n = "top",
  delayDuration: u = 0,
  skipDelayDuration: C = 0,
  noArrow: c = !1,
  sideOffset: x = 5,
  zIndex: m = 0
}, R) => /* @__PURE__ */ e(g, { disableHoverableContent: !0, skipDelayDuration: C, children: /* @__PURE__ */ v(j, { delayDuration: u, children: [
  /* @__PURE__ */ e(P, { ref: R, asChild: !0, children: d }),
  !f && /* @__PURE__ */ e(T, { children: /* @__PURE__ */ e(_, { asChild: !0, className: r(l, t == null ? void 0 : t.root), side: n, sideOffset: x, ...o == null ? void 0 : o.root, children: /* @__PURE__ */ e("div", { className: r($({
    noArrow: c,
    customFont: h,
    css: {
      $$zIndex: m
    }
  }), t == null ? void 0 : t.content), "data-position": n, ...o == null ? void 0 : o.content, children: i }) }) })
] }) }));
export {
  H as default
};
//# sourceMappingURL=Tooltip.es.js.map
